import Adafruit from "../../../../docs/_images/adafruit_io_logo.svg";
import Adc from "../../../../docs/_images/adc_symbol.svg";
import AwsIotCore from "../../../../docs/_images/aws_iot_core.png";
import BluetoothLogo from "../../../../docs/_images/bluetooth_logo.svg";
import CLogo from "../../../../docs/_images/c_logo.svg";
import CellTower from "../../../../docs/_images/cellular_tower.svg";
import Date from "../../../../docs/_images/date.svg";
import Espressif from "../../../../docs/_images/espressif.png";
import GoogleSheets from "../../../../docs/_images/google_sheets.png";
import HelloWorld from "../../../../docs/_images/hello_world.png";
import Http from "../../../../docs/_images/http_logo.svg";
import Binary from "../../../../docs/_images/hw_binary.jpg";
import Bme280 from "../../../../docs/_images/hw_bme280.jpg";
import HwButton from "../../../../docs/_images/hw_button.jpg";
import Buzzer from "../../../../docs/_images/hw_buzzer.jpg";
import Dht11 from "../../../../docs/_images/hw_dht11.jpg";
import Ds18b20 from "../../../../docs/_images/hw_ds18b20.jpg";
import HwLed from "../../../../docs/_images/hw_led.jpg";
import HwLeds from "../../../../docs/_images/hw_leds.jpg";
import Neopixel from "../../../../docs/_images/hw_neopixel.jpg";
import Potentiometer from "../../../../docs/_images/hw_potentiometer.jpg";
import Servo from "../../../../docs/_images/hw_servo.jpg";
import Ssd1360 from "../../../../docs/_images/hw_ssd1306.jpg";
import Ultra from "../../../../docs/_images/hw_ultra.jpg";
import I2c from "../../../../docs/_images/i2c_logo.svg";
import Ota from "../../../../docs/_images/ota.png";
import Packages from "../../../../docs/_images/packages.svg";
import PwmWiki from "../../../../docs/_images/pwm.png";
import Qubitro from "../../../../docs/_images/qubitro_logo.svg";
import Rotary from "../../../../docs/_images/rotary.jpeg";
import SetupIde from "../../../../docs/_images/setup_ide.png";
import Shushing from "../../../../docs/_images/shushing_face.svg";
import Sleep from "../../../../docs/_images/sleep.svg";
import Supabase from "../../../../docs/_images/supabase_logo.svg";
import Telegram from "../../../../docs/_images/telegram_logo.svg";
import Time from "../../../../docs/_images/time.svg";
import ToitLogo from "../../../../docs/_images/toit_logo.svg";
import Watchdog from "../../../../docs/_images/watchdog.svg";
import * as React from 'react';
export default {
  Adafruit,
  Adc,
  AwsIotCore,
  BluetoothLogo,
  CLogo,
  CellTower,
  Date,
  Espressif,
  GoogleSheets,
  HelloWorld,
  Http,
  Binary,
  Bme280,
  HwButton,
  Buzzer,
  Dht11,
  Ds18b20,
  HwLed,
  HwLeds,
  Neopixel,
  Potentiometer,
  Servo,
  Ssd1360,
  Ultra,
  I2c,
  Ota,
  Packages,
  PwmWiki,
  Qubitro,
  Rotary,
  SetupIde,
  Shushing,
  Sleep,
  Supabase,
  Telegram,
  Time,
  ToitLogo,
  Watchdog,
  React
};